import { createSlice } from "@reduxjs/toolkit";

const notificationsListSlice = createSlice({
  name: "authReducer",
  initialState: {
    isFetching: true,
    notifications: [],
  },
  reducers: {
    storeNotifications: (state, action) => {
      const { payload } = action;
      state.notifications = payload;
      state.isFetching = false;
    },
  },
});

export const {
  actions: { storeNotifications },
  reducer: notificationListReducer,
} = notificationsListSlice;
